// i18n: dil URL'den belirlenir. Türkçe sayfalar kökte (/oyna), İngilizce sayfalar /en altında
// (/en/play). Her sayfanın iki dildeki adresi routes.json'da eşlenir; dil değiştirici ve
// hreflang etiketleri bu eşlemeyi kullanır.

import { useMemo } from 'react';
import { useLocation, matchPath } from 'react-router-dom';
import ROUTES from './routes.json';
import STRINGS from './strings';

export const LANGS = ['tr', 'en'];
export { ROUTES };

export function langFromPath(pathname) {
  return pathname === '/en' || pathname.startsWith('/en/') ? 'en' : 'tr';
}

// pathFor('puzzle', 'en', { id: 'tsume-001' }) -> '/en/puzzles/tsume-001'
export function pathFor(key, lang, params = {}) {
  const pattern = ROUTES[key]?.[lang];
  if (!pattern) return lang === 'en' ? '/en' : '/';
  return pattern.replace(/:([a-zA-Z]+)/g, (_, name) => encodeURIComponent(params[name] ?? ''));
}

// Bulunulan adresin rota anahtarını ve parametrelerini çözer.
export function matchRoute(pathname) {
  const clean = pathname.length > 1 ? pathname.replace(/\/+$/, '') : pathname;
  const lang = langFromPath(clean);
  for (const [key, paths] of Object.entries(ROUTES)) {
    const m = matchPath({ path: paths[lang], end: true }, clean);
    if (m) return { key, lang, params: m.params };
  }
  return null;
}

// Aynı sayfanın diğer dildeki adresi (eşleşmezse o dilin ana sayfası).
export function alternatePath(pathname, targetLang) {
  const m = matchRoute(pathname);
  if (!m) return pathFor('home', targetLang);
  return pathFor(m.key, targetLang, m.params);
}

export function useLang() {
  const { pathname } = useLocation();
  const lang = langFromPath(pathname);
  return useMemo(() => {
    const dict = STRINGS[lang];
    const t = (key, vars) => {
      let s = key.split('.').reduce((o, k) => (o ? o[k] : undefined), dict);
      if (s === undefined) s = key;
      if (vars) s = s.replace(/\{(\w+)\}/g, (_, v) => (vars[v] ?? ''));
      return s;
    };
    return {
      lang,
      t,
      to: (key, params) => pathFor(key, lang, params),
      locale: lang === 'en' ? 'en-US' : 'tr-TR',
    };
  }, [lang]);
}
